import { getCurrentInstance } from 'vue'

export function useStore() {
    return getCurrentInstance().proxy.$store
}
